import { render, staticRenderFns } from "./resourceManageDrawer.vue?vue&type=template&id=81420758&scoped=true"
import script from "./resourceManageDrawer.vue?vue&type=script&lang=js"
export * from "./resourceManageDrawer.vue?vue&type=script&lang=js"
import style0 from "./resourceManageDrawer.vue?vue&type=style&index=0&id=81420758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81420758",
  null
  
)

export default component.exports